<template>
  <div class="editor-header">
    <h3>{{ title }}</h3>
    <el-button type="text" size="small" @click="handleClose">
      <i class="el-icon-close"></i>
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'EditorHeader',
  
  props: {
    title: {
      type: String,
      default: '公式编辑器'
    }
  },
  
  methods: {
    // 关闭按钮点击事件处理
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
  }
}
</style>